import { useMutation } from 'react-query';

import { requestTemplateRoute } from '@features/digitalOnboarding';
import axiosInstance from '@server/axiosInstance';

export const useUploadDocument = () => {
  const { mutate: uploadDocument, isLoading: isUploadingDocument } =
    useMutation({
      mutationFn: (variables: { document: File, company_id?: number }) =>
        axiosInstance
          .post(requestTemplateRoute, variables, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => res.data),
    });

  return {
    uploadDocument,
    isUploadingDocument,
  };
};
